module.exports = __webpack_public_path__ + "media/Doorbell_Pairing-Mode_Light.edb4505f.mp4";